const Olam = {
    Product:{
        selectors: {
              swatchItems: document.querySelectorAll('.t4s-swatch__item')
        },
        init: function(){
            this.selectors.swatchItems.forEach((item) => {
                  item.addEventListener('click', () =>{
                    setTimeout(() => {
                        parcelamento();
                    }, 150);
                });
            });
        }
    },
    Quickview: {
        init: function(){
            const swatchItems = document.querySelectorAll('.t4s-swatch__item');
            swatchItems.forEach((item) => {
                item.addEventListener('click', () =>{
                    setTimeout(() => {
                        parcelamento();
                    }, 150);
                });
            });
        }
    }
}